/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Extraction_Complete_UploadingInputs */

const en_audio_extraction_complete_uploading = /** @type {(inputs: Audio_Extraction_Complete_UploadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio extraction complete. Uploading...`)
};

const fr_audio_extraction_complete_uploading = /** @type {(inputs: Audio_Extraction_Complete_UploadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extraction audio terminée. Téléversement...`)
};

const de_audio_extraction_complete_uploading = /** @type {(inputs: Audio_Extraction_Complete_UploadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audioextraktion abgeschlossen. Upload läuft...`)
};

const it_audio_extraction_complete_uploading = /** @type {(inputs: Audio_Extraction_Complete_UploadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estrazione audio completata. Caricamento in corso...`)
};

const ru_audio_extraction_complete_uploading = /** @type {(inputs: Audio_Extraction_Complete_UploadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Извлечение аудио завершено. Загрузка...`)
};

const es_audio_extraction_complete_uploading = /** @type {(inputs: Audio_Extraction_Complete_UploadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extracción de audio completada. Subiendo...`)
};

const zh_cn2_audio_extraction_complete_uploading = /** @type {(inputs: Audio_Extraction_Complete_UploadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音频提取完成。正在上传……`)
};

const ja_audio_extraction_complete_uploading = /** @type {(inputs: Audio_Extraction_Complete_UploadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オーディオの抽出が完了しました。アップロードしています...`)
};

const hi_audio_extraction_complete_uploading = /** @type {(inputs: Audio_Extraction_Complete_UploadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडियो एक्सट्रैक्शन पूरा हो गया है। अपलोड हो रहा है...`)
};

const pt_pt2_audio_extraction_complete_uploading = /** @type {(inputs: Audio_Extraction_Complete_UploadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extração de áudio concluída. Enviando...`)
};

/**
* | output |
* | --- |
* | "Audio extraction complete. Uploading..." |
*
* @param {Audio_Extraction_Complete_UploadingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_extraction_complete_uploading = /** @type {((inputs?: Audio_Extraction_Complete_UploadingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Extraction_Complete_UploadingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_extraction_complete_uploading(inputs)
	if (locale === "de") return de_audio_extraction_complete_uploading(inputs)
	if (locale === "it") return it_audio_extraction_complete_uploading(inputs)
	if (locale === "ru") return ru_audio_extraction_complete_uploading(inputs)
	if (locale === "es") return es_audio_extraction_complete_uploading(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_extraction_complete_uploading(inputs)
	if (locale === "ja") return ja_audio_extraction_complete_uploading(inputs)
	if (locale === "hi") return hi_audio_extraction_complete_uploading(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_extraction_complete_uploading(inputs)
	return en_audio_extraction_complete_uploading(inputs)
});